export const REASON_FIELD = 'reason';

export const REPORT_REASONS = [
  'This review contains hateful, violent, or inappropriate content',
  'This review contains advertising or spam',
  'This review contains conflict of interest',
  'Other',
];
